<div class="card">
    <div class="border-bottom title-part-padding">
        <h4 class="card-title mb-0">Edit Template</h4>
    </div>
    <div class="card-body">
        <% if ( template.status === 'ACTIVE' ) { %>
        <div class="alert alert-warning d-flex align-items-start gap-3 mb-4" role="alert">
            <i class="ti ti-alert-triangle fs-5 mt-1"></i>
            <div>
                <strong>Active Template</strong>
                <p class="mb-0 mt-1">You are about to modify an active template. Please make sure to communicate any changes with the development department of your organisation.</p>
            </div>
        </div>
        <% } %>
        <div class="template-form-container">
            <form id="template-form"
                  class="form-horizontal">

                <div class="mb-3">
                    <label class="form-label" for="template-name">Name <span class="text-danger">*</span>
                    </label>
                    <input type="text"
                           class="form-control"
                           id="template-name"
                           value="<%= template.name %>"
                           name="name"
                           placeholder="Please specify the name" required>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="mb-3">
                    <label class="form-label" for="template-description">Description</label>
                    <textarea class="form-control"
                              id="template-description"
                              name="description"
                              rows="3"><%= template.description || '' %></textarea>
                </div>

                <div class="mb-3">
                    <label class="form-label" for="template-file">Document File (.docx)</label>
                    <% if ( template.filename ) { %>
                    <div class="mb-2 d-flex align-items-center gap-2">
                        <i class="ti ti-file-text text-primary"></i>
                        <span class="text-muted small">Current: <%= template.filename %></span>
                    </div>
                    <% } %>
                    <div style="position: relative; overflow: hidden;">
                        <input type="file"
                               style="position: static; width: auto; height: auto; opacity: 1;"
                               class="form-control"
                               id="template-file"
                               name="file"
                               accept=".docx">
                    </div>
                    <div class="form-text">Leave empty to keep the current file.</div>
                </div>

                <div class="card-body border-top mt-6">
                    <button type="button"
                            data-id="submit-form"
                            class="btn btn-primary">
                        Save Changes
                    </button>
                    <a href="/template/view/<%= template.id %>" class="btn bg-danger-subtle text-danger ms-6">
                        Cancel
                    </a>
                </div>

            </form>
        </div>
    </div>
</div>
